<template>
  <template v-if="propProgress">
    <template v-if="'skeleton' in $slots">
      <slot name="skeleton"/>
    </template>
    <div class="animate-pulse" v-else>
      <div class="mb-8 w-2/3 h-10 bg-basic-subtitle rounded-md"/>
      <div class="my-1 h-4 bg-basic-line rounded-md"/>
      <div class="my-1 h-4 bg-basic-line rounded-md"/>
      <div class="my-1 h-4 bg-basic-line rounded-md"/>
      <div class="w-1/3 my-1 h-4 bg-basic-line rounded-md"/>
      <div class="h-6"/>
      <div class="my-1 h-4 bg-basic-line rounded-md"/>
      <div class="w-3/4 my-1 h-4 bg-basic-line rounded-md"/>
      <div class="h-6"/>
      <div class="h-8"/>
      <div class="mb-6 w-1/3 h-9 bg-basic-subtitle rounded-md"/>
      <div class="my-1 h-4 bg-basic-line rounded-md"/>
      <div class="my-1 h-4 bg-basic-line rounded-md"/>
      <div class="w-1/4 my-1 h-4 bg-basic-line rounded-md"/>
    </div>
  </template>
  <template v-else>
    <slot/>
  </template>
</template>

<script>
import { props } from './props'
import { toRefs } from 'vue'
import useWatch from 'dcode/uses/useWatch'

export default {
  name: 'CSkeleton',
  props,
  setup (props) {
    const { progress } = toRefs(props)

    let time
    const propProgress = useWatch(progress, data => {
      clearTimeout(time)

      if (progress.value && props.delay) {
        time = setTimeout(() => {
          data.value = true
        }, props.delay)
      } else {
        data.value = progress.value
      }
    }, ['mounted'])

    return {
      propProgress
    }
  }
}
</script>

<style lang="scss"/>
